import {State, Module} from 'app/decorators';
import BaseRoute from 'app/routing';
import NutrientPicker from 'app/directives/nutrient.picker';
import UiLocationPicker from 'app/directives/ui.location.picker';

import {ProductsCtrl, ProductCtrl, NotesCtrl, LogCtrl} from './ctrls';
import mainTpl from './templates/main.html';
import configurationTpl from './templates/details.html';
import notesTpl from './templates/notes.html';
import logsTpl from './templates/logs.html';

import tableSectionTpl from './templates/table.section.html';
import detailSectionTpl from './templates/detail.section.html';


@Module({
    name: 'admin.company.products.conf',
    modules: [
        BaseRoute, NutrientPicker, UiLocationPicker
    ],
})
@State({
    name: 'r.in.top.admin.company.productconf',
    url: '/products-configuration',
    template: mainTpl,
    abstract: '.list',
    data: {
        permissions: {
            only: [
                'main.view_productconfiguration',
            ],
        },
    },
    ncyBreadcrumb: {
        skip: true,
        parent: 'r.in.top.admin.company',
    },
})
@State({
    name: 'r.in.top.admin.company.productconf.list',
    url: '?search',
    views: {
        tableView: {
            template: tableSectionTpl,
            controller: ProductsCtrl,
        },
        detailsView: {
            template: detailSectionTpl,
        },
    },
    ncyBreadcrumb: {
        label: 'Products Configuration',
    },
})
@State({
    name: 'r.in.top.admin.company.productconf.list.product',
    url: '/{objectId:int}',
    template: '<ui-view/>',
    abstract: '.detail',
    ncyBreadcrumb: {
        skip: true,
    },
    controller: function ($rootScope, $stateParams) {
        "ngInject";
        $rootScope.selectedObject = $stateParams.objectId;
    },
    resolve: {
        $object: function($stateParams, ProductConfStore) {
            return ProductConfStore.get($stateParams.objectId);
        },
    },
})
@State({
    name: 'r.in.top.admin.company.productconf.list.product.detail',
    url: '/configuration',
    controller: ProductCtrl,
    template: configurationTpl,
    ncyBreadcrumb: {
        label: '{{ vm.object.name }}',
    },
})
@State({
    name: 'r.in.top.admin.company.productconf.list.product.notes',
    url: '/notes',
    controller: NotesCtrl,
    template: notesTpl,
    ncyBreadcrumb: {
        label: 'Notes',
    },
})
@State({
    name: 'r.in.top.admin.company.productconf.list.product.logs',
    url: '/logs',
    controller: LogCtrl,
    template: logsTpl,
    ncyBreadcrumb: {
        label: 'Logs',
    },
})
export default class States { }



// WEBPACK FOOTER //
// ./src/app/admin/product_conf/routing.js